import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>TIPS FOR TAKING CONTROL
                                            </div>
                                            <div className="border_subtitle">External locus of control</div>
                                            <p>If you have an external locus of control you may avoid taking
                                                action because you feel the outcome
                                                is beyond your control. However, feeling you lack control can
                                                negatively affect your performance and
                                                ability to meet demands. Try to focus more on the things that
                                                could positively influence your situation.</p>
                                            <p>Here are some tips to help you:</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading paratop">
                                                <p><span className="brown brownbold">Set yourself clear and challenging goals </span>.
                                                    This will help
                                                    you to define what you want to achieve and see a clear link
                                                    between your actions and the
                                                    desired outcomes.</p></div>
                                            <div className="border_subtitle">Build your self-confidence in your
                                                ability to influence outcomes
                                            </div>
                                            <p>Setting yourself challenging and achievable goals will help. Once
                                                you have achieved them, your
                                                confidence will grow. Evaluate your performance – think
                                                constructively about something you did that led
                                                to a positive outcome and something else that didn’t. Consider
                                                what you could do differently next time.</p>
                                            <div className="border_subtitle">Motivate yourself to take control
                                                and influence the situation
                                            </div>
                                            <p>See section on Gaining Control on the next two pages of this
                                                tool.</p>
                                            <div className="border_subtitle">Develop your problem-solving
                                                skills
                                            </div>
                                            <p>Try to break down a problem or situation into manageable
                                                tasks/goals. Start by defining the
                                                desired outcome (the objective) and think about how you might go
                                                about achieving it (goals).
                                                Think about the influence you can have rather than the influence
                                                you don’t have.</p>
                                            <div className="border_subtitle">Internal Locus of Control</div>
                                            <p>If you have an internal rather than external locus of control you
                                                are likely to be more prepared to
                                                take control of a situation. This is because you already believe
                                                that what you do will influence a
                                                situation and are likely to work hard towards achieving your
                                                desired outcome. You may, therefore,
                                                feel you don’t need advice. However, there are potential
                                                negatives. People with a strong internal
                                                locus of control tend to be very achievement-orientated, which
                                                can mean those around you feel
                                                overlooked. Because you focus on making things happen, you may
                                                try to control everything!
                                                Again, this may damage your relationships with others and cause
                                                you to overload yourself.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading paratop">
                                                <p>Think about others, especially if you’re managing a team.
                                                    Involve all team members in setting
                                                    (and achieving) goals. Don’t steam ahead with the task in
                                                    hand leaving others behind.</p>
                                            </div>
                                            <div className="border_subtitle">When taking control try to
                                                remember
                                            </div>
                                            <p>Consider others’ feelings. You tend to be very
                                                achievement-orientated and may give little
                                                consideration to your team’s feelings. However, you need your
                                                team’s commitment to perform at
                                                their best, so make sure you have regular meetings or catch-ups
                                                and listen to what others tell you.</p>
                                            <div className="border_subtitle">Don’t overload yourself, delegate
                                                some responsibility to others
                                            </div>
                                            <p>You can do this while maintaining overall control, and this will
                                                enable you to focus on the ‘bigger
                                                picture’ while letting others feel involved.</p>
                                            <div className="border_subtitle">Don’t be too hard on yourself</div>
                                            <p>We can control much of what happens in our lives – but not
                                                everything!</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}